/**
 * @format
 */

import { useContext, useEffect, useState } from 'react';

import { Link, useLocation } from 'react-router-dom';

import { EventContext } from '../../../Contexts/EventContext';
import Loading from '../../../Shared/Components/Loading';
import ModalCustom from '../../../Shared/Components/ModalCustom';
import Pagination from '../../../Shared/Components/Pagination';
import { error, success } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import { useAccess } from '../../../Shared/hooks/useAccess';
import Master from '../../Layouts/Master';

const Role = () => {
  const eventContext = useContext(EventContext);
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [roleRemoveId, setRoleRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { canManageRoles } = useAccess();

  useEffect(() => {
    getRole();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);
  const getRole = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/role${search}`,
      {},
      (res) => {
        eventContext.roles = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const removeRole = async (roleId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/panel/role/${roleId}`,
      {},
      (res) => {
        success('نقش مورد نظر با موفقیت حذف شد');
        setRemoveLoading(false);
        setModalIsOpen(false);
        getRole();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست نقش
          </h1>
        </div>
        {canManageRoles() && (
          <Link
            to='/panel/admin/roles/create'
            className='d-flex flex-row btn btn-outline-info '
          >
            <i className='fad fa-plus f-16 mx-2'></i>
            <span className='f-13'>ایجاد نقش</span>
          </Link>
        )}
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.roles?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>شناسه سیستمی</th>
                {canManageRoles() ? <th>عملیات</th> : null}
              </tr>
            </thead>
            <tbody>
              {eventContext.roles?.data?.map((item) => (
                <tr key={item.id}>
                  <th>{item.id}</th>
                  <td>{item.label || item.description || item.name}</td>
                  <td className='text-muted f-12'>{item.name}</td>
                  {canManageRoles() ? (
                    <td>
                      <div className='d-flex flex-row'>
                        <Link
                          to={`/panel/admin/roles/edit/${item.id}`}
                          className='mx-2'
                        >
                          ویرایش
                        </Link>
                        <Link
                          className='mx-2'
                          to='#'
                          onClick={(e) => {
                            e.preventDefault();
                            setRoleRemoveId(item.id);
                            setModalIsOpen(true);
                          }}
                        >
                          حذف
                        </Link>
                      </div>
                    </td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
            <span className='f-13 font-weight-bold text-secondary'>
              برای ایجاد نقش بر روی منوی ایجاد نقش کلیک کنید
            </span>
          </div>
        )}
      </div>
      <div className='w-100 mt-4 d-flex'>
        <Pagination
          totalPage={eventContext.roles?.meta?.pagination?.total_pages}
          basePath='/panel/admin/roles'
        />
      </div>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف نقش مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removeRole(roleRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default Role;
